import { strStyle } from '../css';
export const align = /([()<>=^+_]*)/;
const clPat = o => {
  let c;
  const bb = '\\';
  if (o === '(') { o = bb + '('; c = bb + ')'; }
  if (o === '[') { o = bb + '['; c = bb + ']'; }
  if (o === '{') { c = '}'; }
  return o + '(?:[^' + c + '\\r\\n])+' + c;
};
const clsGuts = clPat('(') + '|' + clPat('[') + '|' + clPat('{');
export const clsId = '((?:' + clsGuts + ')*)';
const rxCls = new RegExp('(' + clsGuts + ')');

export function parseAttrs(bclass, balign, itag, state) {
  const attrs = { style: {} };
  let m;
  bclass = bclass || '';
  const groups = bclass.split(rxCls).filter(x => x);
  // console.log(groups);
  const cls = groups.find(x => x[0] === '(');
  if (cls) parseClass(attrs, cls.substring(1, cls.length - 1));

  let ppmm;
  let lang = groups.find(x => x[0] === '[');
  if (lang) {
    lang = lang.substring(1, lang.length - 1);

    if (itag === 'a') attrs.href = lang;
    else if (itag === 'img') attrs.src = lang;
    else {
      [, ppmm, lang] = lang.match(/(\+\+|--)?(.*)/);
      if (ppmm === '++') state._holdLang = lang;
      else if (ppmm === '--') state._holdLang = null;
      attrs.lang = lang;
    }
  } else if (state._holdLang) attrs.lang = state._holdLang;

  const style = groups.find(x => x[0] === '{');
  if (style) parseStyle(attrs, style.substring(1, style.length - 1), state);
  // const attrs.style = {};
  balign = balign || '';
  /* eslint-disable no-cond-assign */
  if (m = balign.match(/\(/g)) attrs.style.paddingLeft = m.length + 'em';
  if (m = balign.match(/\)/g)) attrs.style.paddingRight = m.length + 'em';
  if (m = balign.match(/\^/g)) attrs.style.paddingTop = m.length + 'em';
  if (m = balign.match(/_/g)) attrs.style.paddingBottom = m.length + 'em';
  if (m = balign.match(/\+/g)) attrs.style.textIndent = m.length + 'em';
  /* eslint-enable no-cond-assign */
  if (balign.match(/=/)) attrs.style.textAlign = 'center';
  else if (balign.match(/<>/)) attrs.style.textAlign = 'justify';
  else if (balign.match(/</)) attrs.style.textAlign = 'left';
  else if (balign.match(/>/)) attrs.style.textAlign = 'right';
  if (!Object.keys(attrs.style).length) delete attrs.style;
  if (Object.keys(attrs).length) return attrs;
}

export function parseClass(attrs, txt) {
  const [classes, id] = (txt || '').split('#');
  if (id) attrs.id = id;
  if (classes) attrs.class = classes;
  return attrs;
}

function parseStyle(attrs, txt, state) {
  strStyle(txt, null, (_key, value) => {
    const nonStyle = /^\+/.test(_key);
    const event = /^@/.test(_key);
    const key = _key.trim().replace(/^[-+@]+/, '')
      .replace(/-([a-z])/g, (_, c) => c.toUpperCase());
    if (key) {
      if (nonStyle && !(key in attrs)) {
        attrs[key] = value || '';
      } else if (event && !(key in attrs)) {
        if (value in state.funcs) {
          attrs[key] = state.funcs[value];
        } else {
          // eslint-disable-next-line no-new-func
          attrs[key] = new Function('event', value);
        }
        console.log('event', key, attrs[key]);
      } else if (!(key in attrs.style)) {
        attrs.style[key] = value || '';
      }
    }
  });
}

export function rxJoin(o) {
  return o.map(rxMap).join('');
}
function rxMap(o) {
  if (o instanceof RegExp) return o.source;
  else if (Array.isArray(o)) return rxJoin(o);
  else return o;
}

export class Parms {
  constructor(obj) {
    Object.assign(this, obj);
  }

  lookBeh(l) {
    const { str, i } = this;
    return str.substr(i - l, l);
  }

  lookAh(l) {
    const { match, str, i } = this;
    return str.substr(i + match.length, l);
  }

  get lb() { return this.lookBeh(1); }
  get la() { return this.lookAh(1); }
}

export function clone(tgt, ...src) {
  while (src.length) {
    const s = src.shift();
    apply(tgt, s, true);
  }
  return tgt;
}

function apply(t, s, deep) {
  if (typeof t !== 'object' || typeof s !== 'object') return;
  for (const k in s) {
    if (typeof s[k] === 'undefined') continue;
    if (deep && typeof s[k] === 'object') {
      if (Array.isArray(s[k]) && !Array.isArray(t[k])) t[k] = [];
      if (typeof t[k] !== 'object') t[k] = {};
      clone(t[k], s[k], true);
    } else t[k] = s[k];
  }
}

export function findMap(arr, cb) {
  for (let i = 0; i < arr.length; i++) {
    const retval = cb(arr[i], i, arr);
    if (retval !== undefined) return retval;
  }
}

export function escapeRegExp(text) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

export function getProp(obj, path, def) {
  if (typeof path === 'string') path = path.split('.');
  while (path.length && typeof obj === 'object') {
    obj = obj[path.shift()];
  }
  return obj ?? def;
}
